import { ContentHeader } from '@components';
const Page404 = () => {
    return (
        <>
            <ContentHeader title="404 Error Page" />
            <section className="content">
                <div className="error-page">
                    <h2 className="headline text-default"> 404</h2>
                    <div className="error-content">
                        <h3><i className="fas fa-exclamation-triangle text-default"></i> Oops! Page not found.</h3>
                        <p>
                            We could not find the page you were looking for.
                            Meanwhile, you may <a href="/">return to dashboard</a> or try using the search form.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Page404;
